import { IState } from '../../../store';
import { selectAgentLists } from '../selectAgentLists';

export const isShowEncumbranceDisclaimer = (state: IState) => {
  const agentLists = selectAgentLists(state);

  return agentLists.includes('encumbranceRealty');
};
